import React, { ComponentProps, useState } from 'react';
import FormsRow from '../../../components/molecules/Form/components/FormsRow/FormsRow';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useDelayed } from '../../../hooks/useDelayed';
import { useRefreshBlockInDefaultView } from '../../../_lib/BlockFetcher';
import { Form, Input, SubmitButton, Switch, useForm } from '../../../_lib/Form2';
import { ThreadListInfo } from '../partials/ThreadListInfo';

type EditViewProps = { form: any };

function ThreadListEdit({ form }: EditViewProps) {
  const { refresh } = useRefreshBlockInDefaultView();
  const delayedRefresh = useDelayed(refresh);
  const { t } = useSonTranslation('ThreadlistBlock');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: delayedRefresh,
  });

  const cleanupOldPostsEnabledParams = params.getByName('cleanupOldPostsEnabled');
  const cleanupOldPostsAfterDaysParams = params.getByName('cleanupOldPostsAfterDays');

  const [cleanupOldPostsEnabledState, setCleanupOldPostsEnabledState] = useState<boolean>(
    cleanupOldPostsEnabledParams.checked,
  );

  return (
    <>
      <Form id="thread-settings-form" {...formProps}>
        <>
          <FormsRow>
            <Switch
              label={t('edit.label')}
              param={cleanupOldPostsEnabledParams}
              onChange={() => setCleanupOldPostsEnabledState(!cleanupOldPostsEnabledState)}
            />
          </FormsRow>
          {cleanupOldPostsEnabledState && (
            <FormsRow>
              <Input
                label={t('edit.input.label')}
                helpText={t('edit.input.helpText')}
                param={cleanupOldPostsAfterDaysParams}
              />
            </FormsRow>
          )}
          <SubmitButton
            buttonLabel={t('edit.submit')}
            messageSuccess={t('edit.status.success')}
            messageSending={t('edit.status.sending')}
            messageFail={t('edit.status.fail')}
            fetchState={fetchState}
          />
        </>
      </Form>
      <ThreadListInfo
        dayCount={cleanupOldPostsAfterDaysParams.value}
        cleanupOldPostsEnabled={cleanupOldPostsEnabledParams.checked}
      />
    </>
  );
}

export const ThreadListEditView = asFetchableView(ThreadListEdit);
export type ThreadListEditView = ComponentProps<typeof ThreadListEditView>;
